import { getConfig, addressListCode, getDictData } from '@/api/app'
import { getOrganizerIdType } from '@/api/filings'
import { defineStore } from 'pinia'
import { getBaseCode, getEnum } from '@/api/config'
import { baseCodeType } from '@/types/index'
import { addressGroup } from '@/utils/filing'
import { recordsConfig } from '@/api/config'
import configs from '@/config'
import { RecordsConfigEnum } from '@/enums/appEnums'
import { isElectronicVerification } from '@/utils/filing'
import { strToArray } from '@/utils/util'

interface treeType {
    value: number
    name: string
    child?: treeType
}

interface AppSate {
    reConfig: Record<string, any>
    config: Record<string, any>
    isMobile: boolean
    isCollapsed: boolean
    isRouteShow: boolean
    addressList: Array<treeType>
    provinceList: Array<treeType>
    unitNatureList: Array<treeType>
    dictData: any
    baseCode: any
    enumData: any
    icpParamsConig: {
        system: any
        verification: any
    }
}

const useAppStore = defineStore({
    id: 'app',

    state: (): AppSate => {
        return {
            reConfig: {},
            config: {},
            isMobile: true,
            isCollapsed: false,
            isRouteShow: true,
            // 地址信息
            addressList: [],
            // 省份信息
            provinceList: [],
            // 主办单位证件类型
            unitNatureList: [],
            dictData: {},
            // 基础代码
            baseCode: {
                unit_type: [], //'单位分类代码'
                nature: [], //'单位性质代码'
                address: [], //'区域代码'
                question: [], //'意见反馈问题分类代码'
                bureau: [], //'管局信息分类代码(服务器放置地)'
                industry: [], //'行业分类代码'
                alevel: [], //'行政级别代码'
                card_type: [], //'证件类型代码'
                operate: [], //'网站经营内容类型代码（专项审批）'
                web_server: [], //'网站服务内容类型代码'
                interface: [], //'网站接入方式代码'
                off: [], //'注销理由代码'
                notfd: [], //'未备案独立域名处理代码'
                verify: [], //'核实意见代码'
                domain_type: [], //'域名类型代码'
                file_format: [], //'附件文件格式代码'
                file_use_to: [], //'附件用途代码'
                lang: [], //'网站语言类别代码'
                socket: [], //'及时通讯代码'
                app_server_type: [], //'应用服务类型代码'
                resources: [], //'资源类型代码'
                app_xkserver_type: [], //'APP/小程序/快应用服务类型代码表'
                skd_server_cs: [], //'SDK服务厂商代码表'
                sdk_server_type: [] //'SDK服务类型代码表'
            },
            // 枚举类型
            enumData: {
                //  备案状态
                filings_status: [],
                //  备案来源类型
                filings_source_type: [],
                //  核实方法类型
                verify_type: []
            },
            // icp参数配置
            icpParamsConig: {
                // 系统配置
                system: {
                    bureau_communication: '',
                    is_strict_check: '',
                    default_end_ip: '',
                    default_start_ip: '',
                    server_address: []
                },
                // 电子核验配置
                verification: {
                    verification_model: '',
                    verification_platform: ''
                }
            }
        }
    },
    actions: {
        getImageUrl(url: string) {
            return url ? `${this.config.oss_domain}${url}` : ''
        },
        getConfig() {
            return new Promise((resolve, reject) => {
                getConfig()
                    .then((data) => {
                        this.config = data
                        resolve(data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        // 获取配置信息
        recordsConfig() {
            return new Promise((resolve, reject) => {
                const { COMPANY } = RecordsConfigEnum
                const type = COMPANY
                const params = {
                    type
                }
                recordsConfig(params)
                    .then((data) => {
                        const setTitle = () => {
                            const title =
                                data?.company?.systeam_name || configs.title
                            document.title = title
                        }
                        setTitle()
                        this.reConfig = data
                        resolve(data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },

        setMobile(value: boolean) {
            this.isMobile = value
        },
        toggleCollapsed(toggle?: boolean) {
            this.isCollapsed = toggle ?? !this.isCollapsed
        },
        refreshView() {
            this.isRouteShow = false
            nextTick(() => {
                this.isRouteShow = true
            })
        },
        // 获取地址
        getAddressList() {
            return new Promise((resolve, reject) => {
                const params = { is_group: 1 }
                addressListCode(params)
                    .then((data) => {
                        const address = addressGroup(data)
                        this.addressList = address
                        resolve(address)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        // 获取省份列表
        getProvinceList() {
            return new Promise((resolve, reject) => {
                const params = { level: 1 }
                addressListCode(params)
                    .then((data) => {
                        this.provinceList = data
                        resolve(data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        // 获取主办单位证件类型
        getOrganizerIdType() {
            return new Promise((resolve, reject) => {
                const params = { ix: 1 }
                getOrganizerIdType(params)
                    .then((data) => {
                        this.unitNatureList = data
                        resolve(data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        // 字典数据
        getDictData(type: string) {
            return new Promise((resolve, reject) => {
                const params = { type }
                getDictData(params)
                    .then((data) => {
                        this.dictData = data
                        resolve(data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        // 获取基础数据(新字典)
        getBaseCode(type: string = baseCodeType.join(',')) {
            return new Promise((resolve, reject) => {
                const params = { type }
                getBaseCode(params)
                    .then((data) => {
                        const { off } = data
                        if (off) {
                            // 注销原因排序
                            data['off'] = off.sort(
                                (a, b) => a['value'] - b['value']
                            )
                        }

                        this.baseCode = data
                        resolve(data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        // 获取枚举数据
        getEnum(type: string) {
            return new Promise((resolve, reject) => {
                const params = { type }
                getEnum(params)
                    .then((data) => {
                        this.enumData = data
                        resolve(data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        // 获取ICP配置
        getIcpConfig() {
            return new Promise((resolve, reject) => {
                const { SYSTEM, VERIFICATION } = RecordsConfigEnum
                const type = [SYSTEM, VERIFICATION].join(',')
                const params = {
                    type
                }
                recordsConfig(params)
                    .then((data) => {
                        if (Array.isArray(data)) {
                            resolve({})
                            return
                        }
                        const { system, verification } = data
                        if (system) {
                            this.icpParamsConig.system = system
                            this.icpParamsConig.system.server_address =
                                strToArray(system.server_address)
                            this.icpParamsConig.verification = verification
                        }
                        resolve(data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        }
    },
    getters: {
        // 显示footer
        showFooter(): boolean {
            return (
                this.reConfig.company?.company_name ||
                this.reConfig.company?.card_number ||
                this.reConfig.company?.icp_code
            )
        },
        // 是否电子核验
        isElectronicVerify(): boolean {
            return isElectronicVerification(
                this.icpParamsConig.verification?.verification_model
            )
        },
        // 电子核验平台
        electronicVerifyPlatform(): string | number {
            return this.icpParamsConig.verification?.verification_platform
        }
    }
})

export default useAppStore
